import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalise le `detail` d'erreur en CHAÎNE (FastAPI renvoie un tableau d'objets
// pour les erreurs 422, ce qui faisait planter le rendu React -> page noire).
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const d = error?.response?.data?.detail;
    if (Array.isArray(d)) {
      const first = d[0] || {};
      const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : "";
      const isEmail = field === "email" || (first.msg || "").toLowerCase().includes("email");
      error.response.data.detail = isEmail
        ? "Adresse email invalide (ex : nom@domaine.com)."
        : (first.msg || "Données invalides.");
    } else if (d && typeof d === "object") {
      error.response.data.detail = "Une erreur est survenue.";
    }
    return Promise.reject(error);
  }
);

export default api;
